module.exports = __webpack_public_path__ + "static/img/faceError.8acd385.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/motor/components/personInfo/personFace/faceError.png
// module id = 1sUc
// module chunks = 2